import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
    "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
    {
        variants: {
            variant: {
                default:
                    "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
                secondary:
                    "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
                destructive:
                    "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
                outline: "text-foreground",
                new: "border border-status-new-border bg-status-new-background text-status-new-text",
                review: "border border-status-review-border bg-status-review-bg text-status-review-text",
                accepted:
                    "border border-status-accepted-border bg-status-accepted-bg text-status-accepted-text",
                declined:
                    "border border-status-declined-border bg-status-declined-bg text-status-declined-text",
                "category-a":
                    "border border-categories-a-border bg-categories-a-bg text-categories-a-text capitalize",
                "category-b":
                    "border border-categories-b-border bg-categories-b-bg text-categories-b-text capitalize",
                "category-c":
                    "border border-categories-c-border bg-categories-c-bg text-categories-c-text capitalize",
                "category-d":
                    "border border-categories-d-border bg-categories-d-bg text-categories-d-text capitalize",
                complete:
                    "border border-voting-complete-border bg-voting-complete-bg text-voting-complete-text capitalize",
                incomplete:
                    "border border-voting-incomplete-border bg-voting-incomplete-bg text-voting-incomplete-text capitalize",
                "age-group":
                    "capitalize border border-app-cream bg-app-cream text-app-default text-xs capitalize",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    }
)

export interface BadgeProps
    extends
        React.HTMLAttributes<HTMLDivElement>,
        VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
    return (
        <div className={cn(badgeVariants({ variant }), className)} {...props} />
    )
}

export { Badge, badgeVariants }
